export const getTextValueFromObjectUsingValue = (object, value) => {
  for (var j = 0; j < object.length; j++) {
    if (value == object[j].value) {
      return object[j].text
    }
  }
}

export const filterDealsBasedOn = (deals, input) => {
  return deals.filter(deal => textMatchDeal(deal, input));
}

export const filterListingsBasedOn = (listings, input) => {
  return listings.filter(listing => textMatch(listing, input));
}

export const filterMarketplaceListingsBasedOn = (listings, input) => {
  return listings.filter(listing => textMarketplaceListingMatch(listing, input));
}

function textMarketplaceListingMatch(listing, input) {
  var searchTerm = input.toLowerCase()
  var itemText = ""


  itemText+= safeObjectRead(listing, 'marketingDet.shortDesc')

  var tags = safeObjectRead(listing, 'marketingDet.tagwords')
  tags?itemText+= tags.toString(): void 0;
  itemText+= safeObjectRead(listing, 'location.address.formattedAD')
  itemText+= safeObjectRead(listing, 'genDet.slogan.est')
  itemText+= safeObjectRead(listing, 'genDet.slogan.eng')
  itemText+= safeObjectRead(listing, 'genDet.slogan.rus')

  var pm = safeObjectRead(listing, 'txnDet.priceMonthly')
  pm?itemText+=pm.toString():void 0; 
  var pd = safeObjectRead(listing, 'txnDet.priceDaily')
  pd?itemText+=pd.toString():void 0; 

  var res = itemText.toLowerCase().indexOf(searchTerm) !== -1
  return res
}


// TODO: Add alias for mnt and pst
function textMatch(listing, input) {
  var searchTerm = input.toLowerCase()
  var itemText = ""
  itemText+= safeObjectRead(listing, 'marketingDet.shortDesc')
  itemText+= safeObjectRead(listing, 'maaklerID')
  itemText+= safeObjectRead(listing, 'location.address.municipality')
  itemText+= safeObjectRead(listing, 'location.address.street') + " " + safeObjectRead(listing, 'location.address.number')
  itemText+= safeObjectRead(listing, 'genDet.info.est')
  itemText+= safeObjectRead(listing, 'genDet.info.eng')
  itemText+= safeObjectRead(listing, 'genDet.info.rus')

  var res = itemText.toLowerCase().indexOf(searchTerm) !== -1
  return res
}

function textMatchDeal(deal, input) {
  var searchTerm = input.toLowerCase()
  var itemText = ""

  itemText+= safeObjectRead(deal, 'lesseeDet.privatePerson.givenName')
  itemText+= safeObjectRead(deal, 'lesseeDet.privatePerson.surname')
  itemText+= safeObjectRead(deal, 'lesseeDet.privatePerson.idCode')
  itemText+= safeObjectRead(deal, 'lesseeDet.privatePerson.email')
  itemText+= safeObjectRead(deal, 'lesseeDet.privatePerson.phone')
  itemText+= safeObjectRead(deal, 'lesseeDet.privatePerson.address')
  itemText+= safeObjectRead(deal, 'lesseeDet.jurPerson.name')
  itemText+= safeObjectRead(deal, 'property.address.county')
  itemText+= safeObjectRead(deal, 'property.address.municipality')
  itemText+= safeObjectRead(deal, 'property.address.street') + " " + safeObjectRead(deal, 'property.address.number')
  itemText+= safeObjectRead(deal, 'contractDetails.terms.price')
  var res = itemText.toLowerCase().indexOf(searchTerm) !== -1
  return res
}

const safeObjectRead = (object, path = '') =>
  path.split('.')
    .reduce((o, x) => o == undefined ? o : o[x]
      , object)



// WEBPACK FOOTER //
// ./src/searchFunctions.js